import { RootState } from 'store/root-reducer';

export const getIntrudersList = (state: RootState) => state.statistics.intrudersList;
